const TOKEN_PATTERN = /\{(\w+)\}/g;

export const interpolateText = (template: string, vars: Record<string, string | number>): string =>
	template.replace(TOKEN_PATTERN, (match, key: string) =>
		key in vars ? String(vars[key]) : match
	);

interface ProgressLabelInput {
	current: number;
	score: number;
	total: number;
}

export const formatProgressLabel = (
	format: string,
	{ current, score, total }: ProgressLabelInput
) => {
	const pad = (value: number) => String(value).padStart(String(total).length, '0');

	return interpolateText(format, {
		current: pad(current),
		score: pad(score),
		passed: pad(score),
		failed: pad(total - score),
		total
	});
};
